// PlaceToPay (Evertec) WebCheckout — create-session API client.
//
// Hits payment-gateway's REST endpoint, not the GraphQL endpoint, because the
// session creation is a vendor-specific flow that bypasses the canonical
// authorize/capture pipeline.
//
// URL is environment-driven via REACT_APP_PLACETOPAY_SESSION_URL.
// Selfcare uses a runtime-config pattern: env.sh writes the container's env
// vars into /env-config.js at startup, which sets window._env_.X. We read
// from window._env_ first (runtime, set by helm) and fall back to process.env
// (build-time, set by .env at CI). Never hardcoded.

function getEnv(key) {
  if (typeof window !== 'undefined' && window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  return process.env[key];
}

const PLACETOPAY_SESSION_URL = getEnv('REACT_APP_PLACETOPAY_SESSION_URL');

export default async function createPlaceToPaySession(body) {
  if (!PLACETOPAY_SESSION_URL) {
    throw new Error(
      'createPlaceToPaySession: REACT_APP_PLACETOPAY_SESSION_URL is not set. ' +
      'Check helm_values/<tenant>/selfcare-ui.yaml.'
    );
  }
  const response = await fetch(PLACETOPAY_SESSION_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    // credentials:'include' is supported because payment-gateway's CrossOriginFilter
    // echoes the specific Origin (not '*') and sets Access-Control-Allow-Credentials:
    // true for allowlisted *.embrix.org callers. See CrossOriginFilter.groovy.
    credentials: 'include',
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(`createPlaceToPaySession HTTP ${response.status}: ${text}`);
  }
  return response.json();
}
